<template lang="pug">
  span.p-price__price
    span.p-price__offscreen(v-text="surface")
    span(aria-hidden="true")
      span.p-price__symbol(v-html="symbol")
      span.p-price__whole(v-text="whole")
        span.p-price__decimal(v-text="decimal")
      span.p-price__fraction(v-text="fraction")
      template(v-if="priceObject.max")
        span.p-price__to= ' - '
        span.p-price__symbol(v-html="symbol")
        span.p-price__whole(v-text="priceObject.max.whole")
          span.p-price__decimal(v-text="decimal")
        span.p-price__fraction(v-text="priceObject.max.fraction")

      slot

</template>

<script>
export default {
  props: {
    /*
    priceObject
    {
      surface: [正式表記価格],
      symbol: [通貨記号],
      decimal: [小数点],
      min: { // 必須
        whole: [自然数価格],
        fraction: [少数価格]
      },
      max: {
        whole: [自然数価格],
        fraction: [少数価格]
      }
    }
     */
    priceObject: {
      type: Object,
      required: true
    },
    prependSymbol: {
      type: String,
      default: ''
    }
  },

  computed: {
    surface() {
      return this.priceObject.surface || '';
    },
    symbol() {
      return `${this.prependSymbol}${this.priceObject.symbol}` || '';
    },
    whole() {
      return this.priceObject.min.whole;
    },
    decimal() {
      return this.priceObject.decimal || '.';
    },
    fraction() {
      return this.priceObject.min.fraction;
    }

  }
};
</script>

<style scoped>

</style>
